module.exports = __webpack_public_path__ + "img/news3-5.05202cd7.png";